import comp from "./NotificationCard";
export default comp;
